import constant from '../../constant';
import {reportUg} from "../../../utils/stat";
import {statTicket} from "../../../utils/stat";


const setSecSharePopStatus = (params = {}) => {
  const {show} = params;

  if (show) { // || !isTbsEnv
    statTicket({user_action: 'twice_share_window_expose'});
    reportUg(2, 'twice_share_window');
    params.smallText = false;
  } else {
    params.show = false;
  }
  return {
    type: constant.SECOND_SHARE.SHARE_POP,
    ...params
  }
}

export default {
  setSecSharePopStatus,
}